import React from "react";
import { useTranslation } from "react-i18next";
import { TouchableOpacity } from "react-native";
import { SEO } from "components/Seo/Seo";
import { Layout } from "components/Layout/Layout";
import { BookServicePill } from "components/BookServicePill/BookServicePill";
import { Text } from "@clearabee/ui-library-native";
import { IconPanel } from "components/IconPanel/IconPanel";
import { useRouter } from "lib/hooks/useRouter";
import { DashboardInfo } from "components/DashboardInfo/DashboardInfo";

export const GuestDashboard = (): React.ReactElement => {
  const [translate] = useTranslation();
  const { navigate } = useRouter("Dashboard");

  return (
    <>
      <SEO title={translate("hwa.screens.dashboard.title")} />
      <Layout title="Home">
        <BookServicePill />
        <TouchableOpacity
          onPress={() => {
            navigate({
              routeName: "Login",
            });
          }}
        >
          <IconPanel
            backgroundColor="brand.darker"
            iconColor="brand.dark"
            icon="Hourglass"
            subtitle="SAVE TIME"
            subtitleColor="warning"
          >
            <Text
              color="light"
              styles={{
                fontFamily: "ProximaSemiBold",
              }}
            >
              Login or sign up for an {"\n"}account and manage {"\n"}your
              orders.
            </Text>
          </IconPanel>
        </TouchableOpacity>
        {/* <IconPanel
          backgroundColor="usp"
          icon="Diamond"
          iconColor="usp.light"
          subtitle="SUBSCRIPTION"
          subtitleColor="usp.darkest"
        >
          <Text
            color="light"
            styles={{
              fontFamily: "ProximaSemiBold",
            }}
          >
            Sign up for one of our {"\n"}
            subscription packages {"\n"}
            and SAVE up to £xx.xx!
          </Text>
        </IconPanel> */}
        <DashboardInfo />
      </Layout>
    </>
  );
};
